module.exports = __webpack_public_path__ + "img/Greece.ae479bf7.png";